<template>
  <div>
    <div class="box" :class="boxClass">
      <div
        :class="{ 'box-header with-border': $slots.title || $slots.buttons }"
        v-if="$slots.buttons"
      >
        <h3 :class="{ 'box-title': $slots.title }">
          <slot name="title"></slot>
        </h3>

        <div :class="{ 'box-tools pull-right': true }">
          <slot name="buttons"></slot>
          <button
            type="button"
            class="btn btn-box-tool"
            :data-widget="'collapse'"
            v-if="collapsible"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'box',
  props: {
    collapsible: {
      default: false
    },
    type: {
      default: 'primary',
      type: String
    }
  },
  data() {
    return {
      boxClasses: {
        info: 'box-info',
        success: 'box-success',
        warning: 'box-warning',
        danger: 'box-danger',
        primary: 'box-primary'
      }
    }
  },
  mounted() {
    let slotBody = this.$slots['body']
    if (slotBody) {
      let input = slotBody[0].elm.querySelector('input:not([disabled])')
      if (input) setTimeout(() => input.focus(), 200)
    }
  },
  computed: {
    boxClass() {
      return this.boxClasses[this.type] || this.boxClasses['primary']
    }
  }
}
</script>

<style>
@media print {
  .no-print {
    display: none;
  }
}
</style>
